import { withCredentialsClient } from '@/app/shared/services/http-client/http-client.js';
import { appLocalStorage } from '@/app/shared/commonURLs.js';
import axios from 'axios';
import { AppStorage } from '@/app/shared/services/app-storage/app-storage.js';
import { apiBaseUrl } from '@/environment/environment';

let storage = new AppStorage();

export class ChangePasswordService {
    constructor() {

 
        this.ChangePassword = appLocalStorage.SecurityServiceUrl + "security/ChangePassword";
        // console.log(this.ChangePassword)
    }
    changePassword(currentPassword, newPassword,TimeStamp, callback, errCallback) {
         
        withCredentialsClient().get(this.ChangePassword + "?currentPassword=" + currentPassword + "&newPassword=" + newPassword+"&TimeStamp="+TimeStamp).then(callback).catch(errCallback);

    }

     withCredentialsClient() {
        return axios.create({
            baseURL: apiBaseUrl,
            withCredentials: true,
            crossDomain: true,
            headers: {
                'Authentication':
                    storage.getItem('Token') == null ? "" : storage.getItem('Token').Value, 'Content-Type': 'application/json'
            }
    
        });
    }
}

const changePasswordService = new ChangePasswordService();

export { changePasswordService };